import { useApi } from '@/api';
import { Flex, KpiCard, KpiSkeleton } from '@blockanalitica/ui';

type OverallResponse = {
  tvl: string;
  total_supply: string;
  total_borrow: string;
  tvl_change: string | number;
  total_supply_change: string | number;
  total_borrow_change: string | number;
  tvl_change_percentage: string | number;
  total_supply_change_percentage: string | number;
  total_borrow_change_percentage: string | number;
};

export default function TopKpis() {
  const [data, error] = useApi<OverallResponse>({
    url: '/overall/'
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <KpiSkeleton />;
  }

  return (
    <Flex flexDirection="column" gap={['m', 's']}>
      <KpiCard
        title="Total Market Size"
        data={data}
        field="total_supply"
        options={{
          currency: 'USD',
          trend: true
        }}
      />
      <Flex flexDirection={['column', 'row']} gap={['m', 's']}>
        <KpiCard
          title="TVL"
          data={data}
          field="total_available"
          options={{
            currency: 'USD',
            notation: 'compact',
            valueOptions: {
              currencyValueOptions: {
                tooltip: true
              }
            }
          }}
        />

        <KpiCard
          title="Total Borrows"
          data={data}
          field="total_borrow"
          options={{
            currency: 'USD',
            notation: 'compact',
            valueOptions: {
              currencyValueOptions: {
                tooltip: true
              }
            }
          }}
        />
      </Flex>
    </Flex>
  );
}
